
define('app/dashboard/leagues/instances/lgInstanceMain',[
	'domReady',
	'app/dashboard/leagues/instances/lgInstanceApp',
	'app/common/setup'
], function(domReady, LgInstanceApp, Setup){
	domReady(function () {
		Setup.initialize();
		LgInstanceApp.initialize();
    });
});